import { useEffect, useState } from 'react'
import { CloseBtn } from '../../../components/CloseBtn'
import { Button } from 'src/components/Button'
import FormattedMessage from '../../../helpers/FormattedMessage'
import { FormInput, FormDate } from '../../../components/FormInput'
import styles from './FormPage.module.scss'
import { Card } from 'src/components/Card'
import editIcon from '../../../assets/icons/icn_edit-b.svg'
import orderTypes from '../../../assets/OrderTypes.json'
import paymentMethod from '../../../assets/PaymentMethod.json'
import { sendForm } from '../../../helpers/sendForm'

interface IProps {
  setPage: (number: number) => void
  nextStep: () => void
}

export const FormPage = ({ setPage, nextStep }: IProps) => {
  const items = window.localStorage.getItem('School-savedItems') || '[]'

  const [sending, setSending] = useState(false)

  const [step, setStep] = useState(0)
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [mobile, setMobile] = useState('')
  const [company, setCompany] = useState('')
  const [cid, setCID] = useState('')

  const [daddress, setDaddress] = useState('')
  
  // Hardcoded for now
  const datepickerMin: Date = new Date().addDays(10)
  // const datepickerMax: Date = new Date('May 31 2025')
  const [dtime, setDtime] = useState(new Date())

  const [ordertype, setOrdertype] = useState('')
  const [payment, setPayment] = useState('')
  const [recipient, setRecipient] = useState('')
  const [baddress, setBaddress] = useState('')

  const [validationError, setValidationError] = useState(false)

  const validation = {
    name: /^\s*(?:(?:\b[a-zA-Z]+\b)\s*){1,4}$/,
    email: /\S+@\S+\.\S+/,
    mobile: /^\+?\d{5,}$/,
    company: /^.{3,}$/,
    cid: /^\d{7}-\d{1}$/,

    daddress: /^.{4,}$/,
    ordertype: /^.{3,}$/,
    payment: /^.{3,}$/,
    recipient: /\S+@\S+\.\S+/,
    baddress: /^.{4,}$/,
  }

  useEffect(() => {
    window.localStorage.setItem('School-step', '2')

    if ( dtime < datepickerMin ) setDtime( datepickerMin )
      
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getBack = () => {
    setPage(1)
    window.localStorage.setItem('School-step', '1')
  }

  const validationCheckPersonalData = () => {
    if (!validation.name.test(name)) {
      setValidationError(true)
      return false
    }
    if (!validation.email.test(email)) {
      setValidationError(true)
      return false
    }
    if (!validation.mobile.test(mobile)) {
      setValidationError(true)
      return false
    }
    if (!validation.company.test(company)) {
      setValidationError(true)
      return false
    }
    if (!validation.cid.test(cid)) {
      setValidationError(true)
      return false
    }
    setValidationError(false)
    return true
  }

  const validationCheckSecondForm = () => {
    if (!validation.daddress.test(daddress)) {
      setValidationError(true)
      return false
    }
    if (!validation.ordertype.test(ordertype)) {
      setValidationError(true)
      return false
    }
    if (!validation.payment.test(payment)) {
      setValidationError(true)
      return false
    }
    if (!validation.recipient.test(recipient)) {
      setValidationError(true)
      return false
    }
    if (!validation.baddress.test(baddress)) {
      setValidationError(true)
      return false
    }
    setValidationError(false)
    return true
  }

  const next = () => {
    if (step === 0 && validationCheckPersonalData()) {
      setStep(1)
    }
  }

  const sendData = () => {
    if (step === 1 && validationCheckSecondForm()) {
      const formData = {
        name,
        email,
        mobile,
        company,
        cid,
        daddress,
        ordertype,
        dtime,
        payment,
        recipient,
        baddress,
        items: JSON.parse(items),
      }
      !sending && sendForm( 'fredriksonCaps', formData, nextStep)

      setSending(true)
    }
  }

  return (
    <>
      <div className={styles.Wrapper}>
        <div className={styles.Title}>
          <CloseBtn cancel={getBack}/>
          <div className={styles.MainTitile}>
            <FormattedMessage id="CompleteOrder.title"/>
          </div>
          <div className={styles.CompleteOrderDescription}>
            <FormattedMessage id="CompleteOrder.description"/>
          </div>
          <div className={styles.CompleteOrderTitle}>
            <FormattedMessage id="CompleteOrder.tableTitle"/>
          </div>
          {step === 0 &&
          <>
              <div className={styles.Form}>
              <div className={styles.FormItemLeft}>
                      <FormInput
                          value={name}
                          onChange={setName}
                          validation={validation.name}
                          title={'Form.title.name'}
                          placeholder="Kristina Svensson"
                          validationCheck={validationError}
                      />
                  </div>
                  <div className={styles.FormItemRight}>
                      <FormInput
                          value={email}
                          onChange={setEmail}
                          validation={validation.email}
                          title={'Form.title.email'}
                          placeholder="kristina.svensson@email.com"
                          validationCheck={validationError}
                      />
                  </div>
                  <div className={styles.FormItemLeft}>
                      <FormInput
                          value={mobile}
                          onChange={setMobile}
                          type="number"
                          validation={validation.mobile}
                          title={'Form.title.mobile'}
                          placeholder="07001442125"
                          validationCheck={validationError}
                      />
                  </div>
                  <div className={styles.FormItemRight}>
                      <FormInput
                          value={company}
                          onChange={setCompany}
                          title={'Form.title.company'}
                          validation={validation.company}
                          placeholder="Company"
                          validationCheck={validationError}
                      />
                  </div>
                  <div className={styles.FormItemLeft}>
                      <FormInput
                          value={cid}
                          onChange={setCID}
                          type="text"
                          validation={validation.cid}
                          title={'Form.title.company.id'}
                          placeholder="1234567-0"
                          validationCheck={validationError}
                      />
                  </div>
              </div>
              <div className={styles.Terms}>
                  <a href="https://www.fredrikson.fi/privacy-policy/" target="_blank" rel="noreferrer">
                      <FormattedMessage id="CompleteOrder.terms"/>
                  </a>
              </div>
          </>
          }
        </div>
        {step === 0 &&
        <Button
            center
            onClick={next}
            buttonColor
            buttonDescription="CompleteOrder.stage2.button"
        />
        }
        {step === 1 &&
        <>
            <Card altStyle={styles.Finalcollapsed}>
                <div className={styles.Info}>
                    <div className={styles.YourInformationTextBlock}>
                        <h4>{name}</h4>
                        <p><span>{email}</span></p><p><span>{mobile}</span></p>
                        <h4 className={styles.MarginBlock}>{company}</h4>
                        <span>{cid}</span>
                    </div>
                    <button onClick={()=> setStep(0)}
                            className={styles.CardButton}>
                        <img src={editIcon} alt='edit'/>
                    </button>
                </div>

            </Card>
            <div className={styles.DoneWrapper}>
                <div className={styles.Terms}>
                    <a href="https://www.fredrikson.fi/privacy-policy/" target="_blank" rel="noreferrer">
                        <FormattedMessage id="CompleteOrder.terms"/>
                    </a>
                </div>
                <h3 className={styles.FormTitle}><FormattedMessage id="SchoolShop.formPage.formTitle"/></h3>
                <div className={styles.Form}>
                  <div className={styles.FormItemLeft}>
                      <FormInput
                          value={daddress}
                          onChange={setDaddress}
                          validation={validation.daddress}
                          title={'Form.title.delivery.address'}
                          placeholder="Helsinki, Street, 5-12"
                          validationCheck={validationError}
                      />
                  </div>
                  <div className={styles.FormItemRight}>
                    <FormDate
                      value={dtime}
                      onChange={setDtime}
                      title={'Form.title.delivery.time'}
                      startDay={datepickerMin}
                      // endDay={datepickerMax}
                      validate={(d:Date) => {
                        const compare = new Date().setHours(0)
                        console.log(d.getTime(),  compare)
                        return d.getTime() >= compare}
                      }
                    />
                  </div>
                  <div className={styles.FormItemLeft}>
                      <FormInput
                          value={ordertype}
                          onChange={setOrdertype}
                          title={'Form.title.order.type'}
                          validation={validation.ordertype}
                          placeholder="Ennakkotilaus or Täydennystilaus"
                          select={orderTypes}
                          selectDefault={'Ennakkotilaus'}
                          validationCheck={validationError}
                      />
                  </div>
                  <div className={styles.FormItemRight}>
                    <FormInput
                          value={payment}
                          onChange={setPayment}
                          title={'Form.title.payment'}
                          validation={validation.payment}
                          placeholder="Pdf-lasku"
                          select={paymentMethod}
                          selectDefault={'Pdf-lasku'}
                          validationCheck={validationError}
                      />
                  </div>
                  <div className={styles.FormItemLeft}>
                      <FormInput
                          value={recipient}
                          onChange={setRecipient}
                          validation={validation.recipient}
                          title={'Form.title.recipient'}
                          placeholder="Sähköposti"
                          validationCheck={validationError}
                      />
                  </div>
                  <div className={styles.FormItemRight}>
                      <FormInput
                          value={baddress}
                          onChange={setBaddress}
                          validation={validation.baddress}
                          title={'Form.title.billing.address'}
                          placeholder="Osoite"
                          validationCheck={validationError}
                      />
                  </div>
                </div>

                <div className={styles.ButtonCenter}>
                    <Button
                        center
                        onClick={sendData}
                        classWidth
                        buttonDescription={"SchoolShop.formPage.createButton"}
                        buttonColor={false}
                    />
                </div>
            </div>
        </>
        }
      </div>
    </>
  )
}
